export default [
	{
		// Outside /mail (Mail Hub's own namespace): this is not a brand inbox,
		// it is the network's switchboard for which credential actually sends.
		path: '/network/mail-sending-accounts',
		name: 'network-mail-sending-accounts-list',
		component: () => import(/* webpackChunkName: "MailSendingAccountsList" */ '@/views/network/mail-sending-accounts/list.vue'),
		meta: {
			layout: 'content',
			// Matches the endpoint's own role:MGN,admin gate — this is
			// credential management, not general Mail Hub access.
			module: 'MGN,admin',
		},
	},
]
